import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { IHisInformationValue, HisInformationDateTimeValue } from "../../HisInformationValue";
import { DateTimeStringUtility } from "../../../system/DateTimeStringUtility";

export class DefaultDateTimeBehavior implements IHisInfoItemBehavior {
  private _dateTimeFormat?: string;
  private static readonly TimeFormat = "HH : mm";

  constructor(private _key: string, private _dateFormat?: string) {
    this._dateTimeFormat = this._dateFormat + " " + DefaultDateTimeBehavior.TimeFormat;
  }

  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const values =  hisInfoItems.filter(x => x.name === this._key).map(x => x.value);
    const dateTimeValues = values
      .filter(x => !DateTimeStringUtility.isEmptyDate(x))
      .filter(x => isDateOrDateTimeFormat(x));
    const dateTimes = dateTimeValues.map(x => toDateTimeValue(x));
    const format = dateTimeValues.every(x => DateTimeStringUtility.isDateFormat(x))
      ? this._dateFormat
      : this._dateTimeFormat; // YYYYMMDD形式とYYYYMMDDHHmm[ss]形式が混合している場合、YYYYMMDDHHmm[ss]形式に合わせる
    return new HisInformationDateTimeValue(this._key, dateTimes, format);
  }
}

/** YYYYMMDD形式またはYYYYMMDDHHmm[ss]形式か */
function isDateOrDateTimeFormat(value: string): boolean {
  return DateTimeStringUtility.isDateFormat(value) || DateTimeStringUtility.isDateTimeFormat(value);
}

function toDateTimeValue(value: string): Date {
  return DateTimeStringUtility.isDateFormat(value) ? DateTimeStringUtility.toDateValue(value)
    : DateTimeStringUtility.toDateTimeValue(value);
}
